import React from 'react';
import PeriodType from './PeriodType';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import {
  getOptionDetails10001,
  getOptionDetails10002,
  getOptionDetails10004,
  getOptionDetails10005,
  getOptionDetails10007,
} from './questionDetails';
import ProgramImplementation from './ProgramImplementation';

interface DateSectionProps {
  questionId: number;
  pageOptionProps: {
    variant: string;
    options: string[];
    onClick: (value: string) => void;
    getSelected: (val: string) => boolean;
    getLabel: (val: string) => JSX.Element;
  };
}

const DateSection: React.FC<DateSectionProps> = ({
  questionId,
  pageOptionProps,
}) => {
  switch (questionId) {
    case 10001:
      return (
        <PeriodType
          haveExtraDetails={false}
          questionId={questionId}
          pageOptionProps={pageOptionProps}
          getOptionDetails={getOptionDetails10001}
        />
      );
    case 10002:
      return (
        <PeriodType
          haveExtraDetails={true}
          questionId={questionId}
          pageOptionProps={pageOptionProps}
          getOptionDetails={getOptionDetails10002}
        />
      );
    case 10004:
      return (
        <PeriodType
          haveExtraDetails={true}
          questionId={questionId}
          pageOptionProps={pageOptionProps}
          getOptionDetails={getOptionDetails10004}
        />
      );
    case 10005:
      return (
        <PeriodType
          haveExtraDetails={false}
          questionId={questionId}
          pageOptionProps={pageOptionProps}
          getOptionDetails={getOptionDetails10005}
        />
      );
    case 10007:
      return (
        <ProgramImplementation
          haveExtraDetails={false}
          questionId={questionId}
          openProgramOnOptionText="Individual reports for each implementation"
          pageOptionProps={pageOptionProps}
          getOptionDetails={getOptionDetails10007}
        />
      );

    default:
      return (
        <TrueImpactText color="critical">
          This question is not implemented yet.
        </TrueImpactText>
      );
  }
};

export default DateSection;
